module.exports = __webpack_public_path__ + "img/person-with-phone.8eebdda8.png";